import { render, staticRenderFns } from "./rescoursedet.vue?vue&type=template&id=ff378a30&scoped=true&"
import script from "./rescoursedet.vue?vue&type=script&lang=js&"
export * from "./rescoursedet.vue?vue&type=script&lang=js&"
import style0 from "./rescoursedet.vue?vue&type=style&index=0&id=ff378a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff378a30",
  null
  
)

export default component.exports